import { useEffect, useMemo, useTransition } from 'react';
import { Router as ReactRouter } from 'react-router';
import GlobalLoadingIndicator from '../react/components/GlobalLoadingIndicator';
import { isFeatureEnabled } from '../react/services/Features';
import history, { createTransitionedHistory } from './history';

export default function Router({ children }: { children: React.ReactNode }) {
    const [isPending, startTransition] = useTransition();
    const { transitionedHistory, notify, stopAutoNotify } = useMemo(() => createTransitionedHistory(history!), []);

    useEffect(() => {
        const enableTransitions = isFeatureEnabled('FEATURE_routerSuspenseTransitions');

        stopAutoNotify();
        return history?.listen((newLocation, action) =>
            enableTransitions
                ? startTransition(() => {
                      notify(newLocation, action);
                  })
                : notify(newLocation, action)
        );
    }, [notify, stopAutoNotify]);

    return (
        <ReactRouter history={transitionedHistory}>
            {children}
            <GlobalLoadingIndicator isPending={isPending} />
        </ReactRouter>
    );
}
